;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.invoice.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'invoice.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'FACTURES',
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('invoiceList')
        } ],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('invoice', 'model'))
            .then(function (data) {
              return data.data
            })
        }],
        linkedSearch: [ '$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch
        } ],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data
          })
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/invoice/list/templates/invoice-list.template.html',
          controller: 'InvoiceListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/invoice/list/templates/invoice-list-toolbar.template.html',
          controller: 'InvoiceListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Factures'
      }
    }
    $stateProvider
      .state(showState)
  }
})(window.angular)
